import React from "react";
import { v4 as uuidv4 } from "uuid";

import Landing from "./Landing";

import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import instrumentActions from "../../flux/actions/InstrumentActions";
import instrumentListStore from "../../flux/stores/instrument/ListStore";

import { IInstrumentViewData, defaultInstrumentData } from "../../models/instrument/InstrumentViewData";
import { ISidebarDetail, SidebarDetail } from "../../models/shared/SidebarDetail";
import { InstrumentFormData } from "../../models/instrument/InstrumentFormData";
import IActionHeaderFormData, { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";

import * as CONSTANTS from "../../utilities/Constants";

import { Translation } from "react-i18next";
import deviceActions from "../../flux/actions/DeviceActions";
import ConnectFormData from "../../models/device/ConnectFormData";
import { defaultDeviceViewData, IDeviceViewData } from "../../models/device/DeviceViewData";
import instrumentByIdStore from "../../flux/stores/instrument/ByIdStore";
import deviceByIdStore from "../../flux/stores/device/ByIdStore";
import instrumentDeleteStore from "../../flux/stores/Instrument/DeleteStore";
import SidebarLayout from "../shared/SidebarLayout";
import SidebarTitle from "../shared/SidebarTitle";
import triggerNotifications from "../../utilities/TriggerNotifications";
import NoDataFound from "../shared/NoDataFound";
import NoDataOnboarding from '../shared/NoDataOnboarding';
import { INSTRUMENT_CREATE_URL } from '../../utilities/Constants';
import History from "../../utilities/History";
import loadingActions from '../../flux/actions/LoadingActions';
import { Spinner } from "@abb/abb-common-ux-react";


import Sidebar from "../sharedNew/sidebarCommon/sidebar";
import SidebarList from "../sharedNew/sidebarCommon/sidebarList";
import '../sharedNew/sidebarCommon/sidebar.sass';
import SidebarCollapse from "../sharedNew/sidebar/SidebarCollapse";
import instrumentDisableStore from "../../flux/stores/instrument/DisableStore";
import instrumentEnableStore from "../../flux/stores/instrument/EnableStore";

interface IIndexState {
  collapseSidebar: boolean;
  activeId: string;
  activeItem: IInstrumentViewData;
  activeConnectionItem: IDeviceViewData;
  listData: ISidebarDetail[];
  isFullSidebarVisible: boolean;
  searchValue: string;
  isLoading: boolean;
}

export default class Index extends React.Component<{ location: any }, IIndexState> {
  private _mount = false;
  private _reloadFirst = true;
  private _id = "";
  private _isSelectedLink = false;
  private _searchId = "";
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _listData: ISidebarDetail[] = [];

  constructor(props: { location: any }) {
    super(props);
    const searchName = this.props.location &&  this.props.location.state && this.props.location.state.searchName  ? this.props.location.state.searchName : '';
    this._mount = false;

    this.state = {
      collapseSidebar: false,
      activeId: "",
      searchValue: searchName || "",
      activeItem: defaultInstrumentData,
      activeConnectionItem: defaultDeviceViewData,
      listData: [],
      isFullSidebarVisible: true,
      isLoading: false
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    History.replace({ state: {} })
    this._mount = true;

    let id = "";

    /// Set Add Button Event
    const instrumentFormData = new InstrumentFormData(false, uuidv4(), CONSTANTS.DefaultGuid, "", "", "",
      { id: "", name: "", description: "" }, [], [], "", false);
    const connectFormData = new ConnectFormData("", "", "", false, false, "", 3, "", "", "", "", [], 21);

    const addRequest = {
      moduleName: CONSTANTS.MODULE_INSTRUMENT,
      createData: {
        instrumentFormData: instrumentFormData,
        connectFormData: connectFormData
      }
    } as IActionHeaderFormData;
    actionHeaderActions.common(addRequest).then();

    if (this.props.location.state && this.props.location.state.isReloadFirst !== undefined) {
      this._reloadFirst = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;
    }
    if (
      this.props.location.state &&
      this.props.location.state.isSelectedLink !== undefined
    ) {
      this._isSelectedLink = this.props.location.state.isSelectedLink;
      this._searchId = this.props.location.state.id;
    }
    instrumentListStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._listData = [];
        const data = state.instrumentDataList.result as IInstrumentViewData[];
        const items: ISidebarDetail[] = [];
        if (state.instrumentDataList.currentPage === state.instrumentDataList.totalPages || state.instrumentDataList.totalRecords === 0) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        data.forEach(element => {
          items.push(new SidebarDetail(element.id, element.name));
        });
        this._listData = items;
      }
    });

    instrumentByIdStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {

        this.setState({
          activeItem: state.instrumentData,
          activeId: state.instrumentData.id
        });
      }
    });

    instrumentDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload
        setTimeout(() => {
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    deviceByIdStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this.setState({
          activeConnectionItem: state.deviceData
        });
      }
    });

    instrumentDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
      this._reloadFirst = state.reload;
      setTimeout(() => {
        this.getAll();
      }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

     instrumentEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
       if (this._mount) {
       this._reloadFirst = state.reload;
       setTimeout(() => {
         this.getAll();
       }, CONSTANTS.NOTIFICATION_TIMEOUT);
       }
     });
     
    this.getAll();
  }

  private getAll() {
    loadingActions.setLoading(true);
    this.setState({isLoading: true})
    instrumentActions.getAll(false, this._page, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
      this.setState({
        listData: this._listData
      }, () => {
        loadingActions.setLoading(false);
        this.setState({isLoading: false})
        const firstItem = this.state.listData[0];
        if (this._reloadFirst) {
          if (this.state.listData.length > 0) {
            this.triggerGetById(firstItem.id);
          } else {
            const data: IActionHeaderEditData = {
              moduleName: CONSTANTS.MODULE_INSTRUMENT,
              editData: {},
              deleteTitle: CONSTANTS.DELETE_TITLE.format(""),
              deleteId: "",
              isEnableViewAll: false,
              deleteRequestId: uuidv4(),
              deleteMessage: ""
            };
            actionHeaderActions.edit(data).then();
          }
        } else {
          this.triggerGetById(this._id);
        }
        if(this.state.searchValue){
          this.onsearch(this.state.searchValue);
        }
      });

    }).catch(() => {
      loadingActions.setLoading(false)
      this.setState({isLoading: false})
    });
  }

  private triggerGetById(id: string) {

    instrumentActions.getById(id).then(() => {
      deviceActions.getById(id).then(() => {
        this.setEditData();
      }).catch((error: any) => {
        this.setState({
          activeConnectionItem: defaultDeviceViewData
        }, this.setEditData);
        triggerNotifications.errors(error.message, error.data)
      });
    }).catch((error: any) => triggerNotifications.errors(error.message, error.data));
  }

  private setEditData() {
    const receivedData = this.state.activeItem;
    const receivedDeviceData = this.state.activeConnectionItem;
    const editData = {
      instrumentFormData: new InstrumentFormData(true, uuidv4(), receivedData.id, receivedData.name, receivedData.codeId,
        receivedData.serialNumber, receivedData.type,
        receivedData.directionList, receivedData.properties, receivedData.description, receivedData.isCreatedManually),

      connectFormData: new ConnectFormData(receivedDeviceData.ipAddress,
        receivedDeviceData.username, "", false, receivedDeviceData.isAutoLine,
        receivedDeviceData.directory, Number(receivedDeviceData.pollingFrequency), receivedDeviceData.path,
        "", receivedDeviceData.connectionType, receivedDeviceData.connectionTypeId, receivedData.networkConnection, receivedDeviceData.port)
    }
    const data: IActionHeaderEditData = {
      moduleName: CONSTANTS.MODULE_INSTRUMENT,
      editData,
      deleteTitle: receivedData.name,
      deleteId: receivedData.id,
      deleteRequestId: uuidv4(),
      deleteMessage: receivedData.name
    };
    actionHeaderActions.edit(data).then();
  }
  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  }

  public onCreateClick = () => {
    const instrumentFormData = new InstrumentFormData(false, uuidv4(), CONSTANTS.DefaultGuid, "", "", "",
      { id: "", name: "", description: "" }, [], [], "", false);
    const connectFormData = new ConnectFormData("", "", "", false, false, "", 1, "", "", "", "", [], 21);

    const createData = {
      instrumentFormData,
      connectFormData
    }
    History.push(INSTRUMENT_CREATE_URL, createData)
  }

  public onsearch = (value: any) => {
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      instrumentActions.getAll(false, 1, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, value).then(() => {
        loadingActions.setLoading(false);
        this.setState({ listData: this._listData, searchValue: value }
          , () => {
            const firstItem = this.state.listData[0];
            if (this.state.listData.length > 0) {
              if(this._isSelectedLink){
                this.triggerGetById(this._searchId);
              }else{
                this.triggerGetById(firstItem.id);
              }
            }
          })
      })
    } else {
      this.setState({ searchValue: value })
    }
  }

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    instrumentActions.getAll(false, this._page, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, this.state.searchValue).then(() => {
      loadingActions.setLoading(false);
      const data = [...this.state.listData, ...this._listData];
      this.setState({ listData: data });
    }).catch(() => loadingActions.setLoading(false));
  }

  public viewAll() {

    History.push(CONSTANTS.INSTRUMENT_VIEW_ALL);
  }

  onCollapseSidebar = () => {
    this.setState({
      collapseSidebar: !this.state.collapseSidebar
    })
  }

  public render() {
    return (
      <Translation>
        {t => <div className="layout-margin">
        {this.state.isLoading ? (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "90vh" }}><Spinner color="grey" sizeClass="medium" /></div>) : 
          (<>{(this.state.listData.length === 0 && this.state.searchValue.length === 0) ?
            <NoDataOnboarding moduleName={CONSTANTS.MODULE_INSTRUMENT} onCreateClick={this.onCreateClick} authKey={CONSTANTS.AUTHKEY_INSTRUMENT}/> :
            <React.Fragment>
              {
                !this.state.collapseSidebar ?
                  <Sidebar
                  authKey={CONSTANTS.AUTHKEY_INSTRUMENT}
                    onCollapseSidebar={this.onCollapseSidebar}
                    searchValue={this.state.searchValue}
                    onSearch={this.onsearch}
                    onCreateClick={this.onCreateClick}
                    viewAll={this.viewAll}
                    showCloneIcon={false}
                  >
                    <SidebarList
                      onSelectLink={this.onSelectLink}
                      listData={this.state.listData}
                      activeId={this.state.activeId}
                      fetchMore={this.fetchMore}
                      hasMore={this._hasMore}
                      module={CONSTANTS.MODULE_INSTRUMENT}
                    >
                    </SidebarList>
                  </Sidebar>
                  :
                  <SidebarCollapse
                    authKey={CONSTANTS.AUTHKEY_INSTRUMENT}
                    onCollapseSidebar={this.onCollapseSidebar}
                    onCreateClick={this.onCreateClick}
                    viewAll={this.viewAll}
                    showCloneIcon={false}
                  ></SidebarCollapse>
              }

              <div className={!this.state.collapseSidebar ? "main-layout ml-3 no-padding" : "main-full-layout float-right"}>
                <Landing instrumentData={this.state.activeItem}
                  deviceData={this.state.activeConnectionItem} />
              </div>
            </React.Fragment>
          }</>)}
        </div>
        }
      </Translation>
    );
  }
}
